// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS } from '~shared/constants';

export const RefrigerationActionSheet = ({ medicationName }: { readonly medicationName: string }) => {
  return (
    <ActionSheetV2
      title="Refrigeration required"
      analyticsName="checkout refrigeration"
      illustrationSrc={getImage('icePacks')}
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.icePacks}
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>
          Store <Body fontFamily="semibold">{medicationName}</Body> in the refrigerator to ensure it remains stable and
          potent.
        </Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
